export enum ProductType {
    BoxProduct = 'box',
    ExperienceProduct = 'experience',
    ValueVoucherProduct = 'value_voucher',
}
